import React, {useEffect, useState} from 'react';
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";
import functionHandler from "../../../utils/functionHandler";


function ShippingDays(props) {
    const {t} = useTranslation();
    const [days, setDays] = useState(0);

    useEffect(() => {
        functionHandler.getData('/getShippingDays', data => {
            setDays(data.additionalDays);
        })
    }, [days])

    return (
        <div className="shippingdays">
            <Typography variant="caption">{t('shipping.estimatedDelivery')} </Typography>
            <Typography variant="caption">{t('shipping.days', {days: `${days + 3} - ${days + 5}`})}</Typography>
        </div>
    );
}

export default ShippingDays;
